/**
 * Import Dependency
 */
import data from '@/data.json';
import selectOne from '@/helpers/selectOne';

/**
 * Import API
 */

/**
 * Declare Variable
 */
const state = {
  projects : data.projecten,
  active: null, // project slug of opened project
  filters: null, // string, for now
  highlighted: [] // project Ids
}

const getProjectIdFromProject = (project) => {
  return project.id;
}

const getters = {
  
  // Extra props
  getActiveProjectSlug: state => {
    return state.active;
  },
  getActiveProject: (state, getters) => {
    return getters.getProjectBySlug({
      slug: state.active
    })
  },
  getFilters: state => {
    return state.filters;
  },
  getHighlightedProjectList: state => {
    return state.highlighted;
  },

  // Data
  getProjectList: state => {
    return state.projects;
  },
  getProjectBySlug: state => ({ slug }) => {
    return selectOne({
      from: state.projects, 
      property: 'slug', 
      value: slug
    });
  },
  getProjectsByThema: state => ({id}) => {
    return state.projects.filter((item) => {
      return (item.themas && item.themas.includes(id));
    });
  },
  getProjectsByGemeente: state => ({id}) => {
    return state.projects.filter((item) => {
      return (item.gemeenten && item.gemeenten.includes(id));
    });
  },
  getProjectsByWijk: state => ({id}) => {
    return state.projects.filter((item) => {
      return (item.wijken && item.wijken.includes(id));
    });
  },
  getProjectsByPartij: state => ({id}) => {
    return state.projects.filter((item) => {
      return (item.partijen && item.partijen.includes(id));
    });
  },

  // Get ids by ...
  getProjectIdsByThema: (state, getters) => ({id}) => {
    return getters.getProjectsByThema({id}).map(getProjectIdFromProject);
  },
  getProjectIdsByGemeente: (state, getters) => ({id}) => {
    return getters.getProjectsByGemeente({id}).map(getProjectIdFromProject);
  },
  getProjectIdsByWijk: (state, getters) => ({id}) => {
    return getters.getProjectsByWijk({id}).map(getProjectIdFromProject);
  },
  getProjectIdsByPartij: (state, getters) => ({id}) => {
    return getters.getProjectsByPartij({id}).map(getProjectIdFromProject);
  } 

}
const actions = {
  setActiveProject({commit, getters}, {slug}) {
    let project = getters.getProjectBySlug({slug});

    if (project) {
      commit('setActiveProject', {
        slug
      })
    }
  },
  setFilters({commit}, { filters }) {
    commit('setFilters', {
      filters
    });
  },
  setHighlightedProjectList({commit}, { projects }) {
    commit('setHighlightedProjectList', {
      projects
    });
  },
}
const mutations = {
  setActiveProject(state, { slug }) {
    state.active = slug;
  },
  setFilters(state, { filters }) {
    state.filters = filters;
  },
  setHighlightedProjectList(state, { projects }) {
    state.highlighted = projects
  }
}

/**
 * Export
 */
export default {
  state,
  getters,
  actions,
  mutations
}
